export const US_STATES = [
  "Alabama", "Arkansas", "Florida", "Georgia", "Kentucky", "Louisiana", "Mississippi",
  "North Carolina", "South Carolina", "Tennessee", "Texas", "Virginia", "West Virginia",
];
